export default {
	productionControlReport: 'Report kontroly produkce',
	documentsToReview: 'Dokumenty k vyjádření',
	myDocuments: 'Moje dokumenty',
	productionControlSelectionCriteria: 'Kontrola produkce',
	policyNumber: 'Číslo PS',
	client: 'Klient',
	product: 'Produkt',
	documentType: 'Typ dokumentu',
	controlStatus: 'Stav kontroly',
	centralConsent: 'Souhlas centrála',
	statement: 'Vyjádření',
	superior: 'Nadřízený',
	subordinate: 'Podřízený',
	region: 'Region',
	wave: 'Vlna',
	documentTypecontrolStatusStatement: 'Typ dokumentu / Stav kontroly / Vyjádření',
	escalationStatus: 'Stav eskalace',
	completed: 'Splněno',
	onTime: 'V termínu',
	firstEscalation: '1. eskalace',
	secondEscalation: '2. eskalace',
	firstEscalationDate: 'Termín 1. eskalace',
	secondEscalationDate: 'Termín 2. eskalace',
	dueDate: 'Termín splnění',
	report: 'Report',
	search: 'Vyhledat',
	resetCriteria: 'Vymazat kritéria',
	noticeDateCreated: 'Datum zadání',
	noticeUserCreated: 'Login uživatele',
	detail: 'Detail',
	undeliveredDocumentsWarning: 'Ve vybrané vlně evidujeme Vaše nedodané nebo pozdě dodané dokumenty ',
	documentsSum: 'celkem',
};
